import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToastService} from '../toast-service';
import {CommonCrudService} from "../common/common-crud.service";
import {CrystalclearSecurityBackUrl} from "../config/crystalclear-security-back-url";
import {UserGroup} from "../../model/security/user-group";

@Injectable({
  providedIn: 'root'
})
export class SecurityUserGroupService extends CommonCrudService<UserGroup> {

  constructor(http: HttpClient,
              toastService: ToastService) {
    super(http,
      toastService,
      CrystalclearSecurityBackUrl.GET_SECURITY_USER_GROUP_LIST,
      CrystalclearSecurityBackUrl.SAVE_SECURITY_USER_GROUP,
      CrystalclearSecurityBackUrl.DELETE_SECURITY_USER_GROUP);
  }

}
